export const sendEmail = async (
  to: string,
  subject: string,
  message: string
) => {
  if (window.location.host === "localhost:8000") {
    return {
      success: false,
      error: "Cannot send emails locally",
      message: "Must send from Netlify, not locally",
    };
  }

  try {
    const htmlContent = `
      <html>
        <head>
          <title>${subject}</title>
        </head>
        <body>
          ${message}
        </body>
      </html>
    `;

    const response = await fetch("/.netlify/functions/sendEmail", {
      method: "POST",
      body: JSON.stringify({
        to: to,
        subject: subject,
        message: htmlContent,
      }),
    });

    if (!response.ok) {
      return Promise.reject({
        success: false,
        error: `Failed to send email. HTTP status: ${response.status}`,
        message: "Email not sent",
      });
    }

    const response_data = await response.json();

    return {
      success: true,
      email_data: response_data,
    };
  } catch (error) {
    return {
      success: false,
      error: error,
      message: "Email not sent",
    };
  }
};
